import React from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  IconButton,
  Paper,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { Edit } from "@mui/icons-material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import baseURL from "../../config";

const CrewProfileSection = ({ crewData, handleEditClick }) => {
  const [openExpModal, setOpenExpModal] = React.useState(false);
  const [openDocModal, setOpenDocModal] = React.useState(false);

  if (!crewData) return null;

  const documentEntries = Object.entries(crewData).filter(
    ([key, value]) => key.toLowerCase().includes("document") && value?.filePath
  );

  const experiences = crewData.experiences || [];

  return (
    <Box sx={{ mt: 4 }}>
      <TableContainer component={Paper}>
        <Table>
          <TableHead sx={{ backgroundColor: "#1976d2" }}>
            <TableRow>
              <TableCell sx={{ color: "#fff", fontWeight: "bold", width: "100px" }}>Sr. No.</TableCell>
              <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>Personal Info</TableCell>
              <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>Experience</TableCell>
              <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>Next of Kin</TableCell>
              <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>Documents</TableCell>
              <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              {/* Sr. No. */}
              <TableCell>1</TableCell>

              {/* Personal Info */}
              <TableCell>
                <Typography><strong>Name:</strong> {crewData?.name || "N/A"}</Typography>
                <Typography><strong>Email:</strong> {crewData?.email || "N/A"}</Typography>
                <Typography><strong>Mobile:</strong> {crewData?.mobile || "N/A"}</Typography>
                <Typography><strong>Indos No.:</strong> {crewData?.indosno || "N/A"}</Typography>
                <Typography><strong>Rank:</strong> {crewData?.rankname || "N/A"}</Typography>
              </TableCell>

              {/* Experience */}
              <TableCell>
                {experiences.length > 0 ? (
                  <>
                    <Typography><strong>Vessel:</strong> {experiences[0].vessel}</Typography>
                    <Typography><strong>Company:</strong> {experiences[0].company}</Typography>
                    <Typography><strong>Rank:</strong> {experiences[0].rank}</Typography>
                    {/* <Typography><strong>Sign On:</strong> {new Date(experiences[0].joiningDate).toLocaleDateString()}</Typography> */}
                    {/* <Typography><strong>Sign Off:</strong> {new Date(experiences[0].signOffDate).toLocaleDateString()}</Typography> */}
                    {experiences.length > 1 && (
                      <Button size="small" onClick={() => setOpenExpModal(true)} sx={{
                        mt: 1,
                        backgroundColor: "#1976d2",
                        color: "#fff",
                        "&:hover": {
                          backgroundColor: "#125ea2",
                        },
                      }}>
                        Experince
                      </Button>
                    )}
                  </>
                ) : (
                  <Typography color="textSecondary">No Experience</Typography>
                )}
              </TableCell>

              {/* NOK */}
              <TableCell>
                {crewData.NOK?.length > 0 ? (
                  crewData.NOK.map((nok, i) => (
                    <Box key={i} sx={{ mb: 1 }}>
                      <Typography><strong>Name:</strong> {nok.name}</Typography>
                      <Typography><strong>Relation:</strong> {nok.relation}</Typography>
                      <Typography><strong>Mobile:</strong> {nok.mobile}</Typography>
                      <Typography><strong>Email:</strong> {nok.email}</Typography>
                    </Box>
                  ))
                ) : (
                  <Typography color="textSecondary">No NOK Info</Typography>
                )}
              </TableCell>

              {/* Documents */}
              <TableCell>
                {documentEntries.length > 0 ? (
                  <Tooltip title="View Documents">
                    <IconButton onClick={() => setOpenDocModal(true)}>
                      <PictureAsPdfIcon sx={{ color: "#e74c3c" }} />
                    </IconButton>
                  </Tooltip>
                ) : (
                  <Typography color="textSecondary">No Documents</Typography>
                )}
              </TableCell>

              {/* Action */}
              <TableCell>
                <Tooltip title="Edit Crew Info">
                  <IconButton onClick={() => handleEditClick(crewData)}>
                    <Edit sx={{ color: "#1976d2" }} />
                  </IconButton>
                </Tooltip>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      {/* Experience Modal */}
      <Dialog open={openExpModal} onClose={() => setOpenExpModal(false)} maxWidth="sm" fullWidth>
        <DialogTitle>All Experience Entries</DialogTitle>
        <DialogContent dividers>
          {experiences.slice(1).map((exp, idx) => (
            <Box key={idx} sx={{ mb: 2 }}>
              <Typography><strong>Vessel:</strong> {exp.vessel}</Typography>
              <Typography><strong>Company:</strong> {exp.company}</Typography>
              <Typography><strong>Rank:</strong> {exp.rank}</Typography>
              <Typography><strong>Sign On:</strong> {new Date(exp.joiningDate).toLocaleDateString()}</Typography>
              <Typography><strong>Sign Off:</strong> {new Date(exp.signOffDate).toLocaleDateString()}</Typography>
              <hr />
            </Box>
          ))}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenExpModal(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* Documents Modal */}
      <Dialog open={openDocModal} onClose={() => setOpenDocModal(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ fontWeight: 600, textAlign: "center" }}>
          Crew Documents
        </DialogTitle>

        <DialogContent dividers>
          {documentEntries.map(([key, value], index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mb: 2,
                p: 1.5,
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                backgroundColor: "#fff",
              }}
            >
              {/* Left side: index + icon + name */}
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography sx={{ fontWeight: 500, mr: 2 }}>{index + 1}.</Typography>
                <PictureAsPdfIcon sx={{ color: "#e74c3c", mr: 1 }} />
                <Typography sx={{ textTransform: "capitalize" }}>
                  {key.replace("Document", "").replace(/([A-Z])/g, " $1").trim()} Document
                </Typography>
              </Box>

              {/* Right side: download button */}
              <Button
                variant="contained"
                size="small"
                onClick={() => window.open(`${baseURL}/${value.filePath}`, "_blank")}
              >
                Download
              </Button>
            </Box>
          ))}
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenDocModal(false)}>Close</Button>
        </DialogActions>
      </Dialog>

    </Box >
  );
};

export default CrewProfileSection;
